import { ValuationState } from '../../../@types/state-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ValuationResponseDto } from '../../../@types/valuation-types'

export const initialState: ValuationState = {
  isPending: false,
  maxValue: undefined,
  minValue: undefined,
  recommendedValue: undefined,
  lastRequestFingerprint: undefined,
}

const valuationFeatureSlice = createSlice({
  name: 'valuationFeature',
  initialState,
  reducers: {
    valuationRequest(state) {
      state.isPending = true
    },
    valuationSuccess(
      state,
      action: PayloadAction<{ valuationResult: ValuationResponseDto; requestFingerprint: string }>
    ) {
      state.maxValue = action.payload.valuationResult.maxValue
      state.minValue = action.payload.valuationResult.minValue
      state.recommendedValue = action.payload.valuationResult.recommendedValue
      state.lastRequestFingerprint = action.payload.requestFingerprint
    },
    valuationReset(state) {
      state.isPending = false
      state.maxValue = undefined
      state.minValue = undefined
      state.recommendedValue = undefined
      state.lastRequestFingerprint = undefined
    },
    valuationRequestCompleted(state) {
      state.isPending = false
    },
  },
})

export const { valuationRequest, valuationSuccess, valuationReset, valuationRequestCompleted } =
  valuationFeatureSlice.actions
export default valuationFeatureSlice.reducer
